import React, { useState, useEffect } from 'react';

import PasswordReset from '@/components/PasswordReset/PasswordReset';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import User from '@/store/user';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';

export default function ResetPassword({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  const [user, setUser] = useState();

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }
    getConfiguration();
  }, []);

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <PasswordReset config={config} logo={loginLogo ? loginLogo : logo} type={loginConfig} user={user} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps(context) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', context.locale),
    getOrFetchHeaderData('login_logo', context.locale),
    getOrFetchHeaderData('login_page', context.locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    user_credentials: (await import(`../../../prebuild-data/i18n/${context.locale}/user_credentials.json`)).default,
  };

  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
